import {
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuItem,
} from '@cad-arc';
import { AdminStatusSubmenuView, UnitStateData } from '@mark43/cad-api';

export function AdminStatusSubmenu({
    adminStatusSubmenuView,
    onSelect,
}: {
    adminStatusSubmenuView: AdminStatusSubmenuView;
    onSelect: (unitStateData: UnitStateData) => void;
}): React.ReactElement {
    return adminStatusSubmenuView.unitStates.length > 0 ? (
        <ContextMenuSub>
            <ContextMenuSubTrigger>{adminStatusSubmenuView.label}</ContextMenuSubTrigger>
            <ContextMenuSubContent>
                {adminStatusSubmenuView.unitStates.map((unitStateData) => {
                    return (
                        <ContextMenuItem
                            key={unitStateData.id}
                            onSelect={() => onSelect(unitStateData)}
                        >
                            {unitStateData.value}
                        </ContextMenuItem>
                    );
                })}
                {adminStatusSubmenuView.serviceAssignmentStatusSubmenuView.unitStates.length > 0 ? (
                    <ContextMenuSub>
                        <ContextMenuSubTrigger>
                            {adminStatusSubmenuView.serviceAssignmentStatusSubmenuView.label}
                        </ContextMenuSubTrigger>
                        <ContextMenuSubContent>
                            {adminStatusSubmenuView.serviceAssignmentStatusSubmenuView.unitStates.map(
                                (unitStateData) => {
                                    return (
                                        <ContextMenuItem
                                            key={unitStateData.id}
                                            onSelect={() => onSelect(unitStateData)}
                                        >
                                            {unitStateData.value}
                                        </ContextMenuItem>
                                    );
                                }
                            )}
                        </ContextMenuSubContent>
                    </ContextMenuSub>
                ) : (
                    <></>
                )}
            </ContextMenuSubContent>
        </ContextMenuSub>
    ) : (
        <></>
    );
}
